export const __ = (slug: string): string => {
    const translations = (window as any).rz_store_locator.translate
    return translations[slug] ?? slug;
}


export const getKm = (n:number)=>{
    return Math.round(n*10.0)/10.0;
}
